<template>
    <div>
        <template v-if="crud_company === true">
            <div class="global-main p-0">
                <div class="onboarding-form-outer">
                    <div class="onboarding-main">
                        <div class="container">
                            <div class="onboarding-top-steps">
                                <ul class="clearfix onb-steps-list">
                                    <li class="complete-li"> <span class="completed"> <img src="/images/tick-white.png" alt=""> </span> Company Details </li>
                                    <li> <span class="counter"> 2 </span> Required Documents </li>
                                    <li> <span class="counter"> 3 </span> CNIC Details </li>
                                </ul>
                            </div>
                            <div class="onboarding-form">
                                <form id="companyForm" @submit.prevent="updateCompanyDocuments" novalidate>

                                    <div class="form-title">Add Registered Business Bank details:</div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input id="placeOfBirth" type="text"
                                                       class="form-control"
                                                       name="placeOfBirth"
                                                       v-model="form.bankName"
                                                       placeholder="Bank name"
                                                       maxlength="40">
                                                <label for="placeOfBirth" class="absolute-label">Bank name</label>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input id="accountNumber" type="text"
                                                       class="form-control"
                                                       name="accountNumber"
                                                       v-model="form.accountNumber"
                                                       placeholder="Account number"
                                                       maxlength="40">
                                                <label for="accountNumber" class="absolute-label">Account number</label>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input id="accountTitle" type="text"
                                                       class="form-control"
                                                       name="accountTitle"
                                                       v-model="form.accountTitle"
                                                       placeholder="Account title"
                                                       maxlength="40">
                                                <label for="accountTitle" class="absolute-label">Account title</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-title">CNIC Details of Owner/Approver</div>
                                    <div class="row cnic-holder">
                                        <div class="col-md-12">
                                            <div class="form-group upload-outer">
                                                <span class="upload-title"> CNIC Front - Upload <small style="color:#ec6c49">( Required )</small></span>
                                                <input type="file" @change="uploadPaymentSlip($event,'new_cnic_front','user_cnic_front')" class="file-up-btn" accept="image/png, image/gif, image/jpeg" id="new_cnic_front" required/>
                                                <label for="new_cnic_front" class="btn-upload-file">Upload <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Accepted formats: JPEG, JPG or PNG"></i></label>
                                                <span class="uploaded-file"></span>
                                                <label for="new_cnic_front" class="btn-change-file hide"><img src="/images/cross-icon.png" alt=""></label>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group upload-outer">
                                                <span class="upload-title"> CNIC Back - Upload <small style="color:#ec6c49">( Required )</small></span>
                                                <input type="file" @change="uploadPaymentSlip($event,'new_cnic_back','user_cnic_back')" class="file-up-btn" accept="image/png, image/gif, image/jpeg" id="new_cnic_back" required/>
                                                <label for="new_cnic_back" class="btn-upload-file">Upload <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Accepted formats: JPEG, JPG or PNG"></i></label>
                                                <span class="uploaded-file"></span>
                                                <label for="new_cnic_back" class="btn-change-file hide"><img src="/images/cross-icon.png" alt=""></label>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-for="(row, index) in cnicRows" :key="'cnic_row_'+index" :value="'cnic_row_'+index">
                                        <div class="row cnic-holder">
                                            <div class="col-md-12">
                                                <div class="form-group upload-outer">
                                                <span class="upload-title"> CNIC Front - Upload <small
                                                        style="color:#ec6c49">( Required )</small></span>
                                                    <span @click="removeField('cnic_row_'+index)"
                                                          class="remove-fields visibility-hidden">
                                                            Remove</span>
                                                    <input type="file"
                                                           @change="uploadPaymentSlip($event,'new_cnic_front_'+index,'user_cnic_front_'+index)"
                                                           class="file-up-btn" accept="image/png, image/gif, image/jpeg"
                                                           :id="'new_cnic_front_'+index" required/>
                                                    <label :for="'new_cnic_front_'+index" class="btn-upload-file">Upload <i
                                                            class="fas fa-question-circle" data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Accepted formats: JPEG, JPG or PNG"></i></label>
                                                    <span class="uploaded-file"></span>
                                                    <label :for="'new_cnic_front_'+index" class="btn-change-file hide"><img
                                                            src="/images/cross.png" alt=""></label>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group upload-outer">
                                                <span class="upload-title"> CNIC Back - Upload <small
                                                        style="color:#ec6c49">( Required )</small></span>
                                                    <span @click="removeField('cnic_row_'+index)"
                                                          class="remove-fields">
                                                            Remove</span>
                                                    <input type="file"
                                                           @change="uploadPaymentSlip($event,'new_cnic_back_'+index,'user_cnic_back_'+index)"
                                                           class="file-up-btn" accept="image/png, image/gif, image/jpeg"
                                                           :id="'new_cnic_back_'+index" required/>
                                                    <label :for="'new_cnic_back_'+index" class="btn-upload-file">Upload <i
                                                            class="fas fa-question-circle" data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Accepted formats: JPEG, JPG or PNG"></i></label>
                                                    <span class="uploaded-file"></span>
                                                    <label :for="'new_cnic_back_'+index" class="btn-change-file hide"><img
                                                            src="/images/cross.png" alt=""></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="btn-holder text-right pb-3">
                                        <label @click="cnicRows.push(1)"
                                               class="add-fields">
                                            Add Field</label>
                                    </div>

                                    <div class="form-title">Company Documents</div>
                                    <div v-for="required_document in required_documents"  v-bind:value="required_document.id" v-bind:key="required_document.id">
                                        <div  class="form-group upload-outer" v-if="required_document.has_sample == 'NO'">
                                            <span class="upload-title">{{ required_document.doc_title }} <small v-if="required_document.is_required == 'YES'" style="color:#ec6c49">( Required )</small></span>
                                            <input type="file" @change="uploadPaymentSlip($event,'static_'+required_document.id ,required_document.doc_name)" class="file-up-btn" accept=".pdf" v-bind:id="'static_'+required_document.id" required/>
                                            <label v-bind:for="'static_'+required_document.id" class="btn-upload-file">Upload <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Accepted format: PDF"></i></label>
                                            <span class="uploaded-file"></span>
                                            <label v-bind:for="'static_'+required_document.id" class="btn-change-file hide"><img src="/images/cross-icon.png" alt=""></label>
                                        </div>
                                        <div  class="form-group upload-outer p-0" v-else>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group upload-outer download-outer">
                                                        <span class="upload-title">{{ required_document.doc_title }} <small v-if="required_document.is_required == 'YES'" style="color:#ec6c49">( Required )</small></span>
                                                        <a v-bind:href="sample_documents_bucket_path+required_document.sample_path" target="_blank" class="download-inner"><i class="fas fa-file-alt"></i> Download Sample</a>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group upload-outer">
                                                        <span class="upload-title">Upload File after filling</span>
                                                        <input type="file" @change="uploadPaymentSlip($event,'static_'+required_document.id ,required_document.doc_name)" class="file-up-btn" accept=".pdf" v-bind:id="'static_'+required_document.id" required/>
                                                        <label v-bind:for="'static_'+required_document.id" class="btn-upload-file">Upload <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Accepted format: PDF"></i></label>
                                                        <span class="uploaded-file"></span>
                                                        <label v-bind:for="'static_'+required_document.id" class="btn-change-file hide"><img src="/images/cross-icon.png" alt=""></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="required_document.is_multiple == 'YES'">
                                            <div v-for="(row, index) in rows" :key="required_document.id+'_'+index" :value="required_document.id+'_'+index">
                                                <div v-if="required_document.id === row.id">
                                                    <div class="form-group upload-outer">
                                                    <span class="upload-title">{{ row.doc_title }} <small
                                                            v-if="row.is_required == 'YES'"
                                                            style="color:#ec6c49">( Required )</small></span>
                                                        <input type="file"
                                                               @change="uploadPaymentSlip($event, required_document.id+'_'+index , row.doc_name+'_'+index)"
                                                               class="file-up-btn" accept=".pdf"
                                                               v-bind:id="required_document.id+'_'+index" required/>
                                                        <span @click="removeField(required_document.id+'_'+index)"
                                                              class="remove-fields">
                                                            Remove</span>
                                                        <label v-bind:for="required_document.id+'_'+index"
                                                               class="btn-upload-file">Upload
                                                            <i class="fas fa-question-circle" data-toggle="tooltip"
                                                               data-placement="top"
                                                               title="Accepted format: PDF"></i></label>
                                                        <span class="uploaded-file"></span>
                                                        <label v-bind:for="required_document.id+'_'+index"
                                                               class="btn-change-file hide"><img
                                                                src="/images/cross.png"
                                                                alt=""></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btn-holder text-right pb-3">
                                            <label @click="addMoreFields(required_document)"
                                                   v-if="required_document.is_multiple === 'YES'"
                                                   for="" class="add-fields">
                                                Add Field</label>
                                        </div>
                                    </div>
                                    <div class="tab-content-inner">

                                    </div>

                                    <div class="btn-holder text-right pb-lg-5 pb-3">
                                        <router-link :to="{path: '/editOnboardedCompany/' + form.companyId}" class="btn mr-2 btn-cancel">Previous</router-link>
                                        <button type="submit" class="btn-submit" id="btn-submit">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="crud_company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    fromWeb: 1,
                    documents: [],
                    bankName: '',
                    accountNumber: '',
                    accountTitle: ''
                }),
                crud_company: null,
                required_documents: null,
                documents_bucket_path: '',
                sample_documents_bucket_path: '',
                company_details: [],
                uploaded_documents: [],
                company_users: [],
                rows: [],
                cnicRows: [],
            }
        },
        methods: {
            uploadPaymentSlip(e, id, name) {
                var fileName = e.target.files[0].name;
                var fileExt = e.target.files[0].type;

                $("#"+id).siblings(".uploaded-file").html(fileName);
                $("#"+id).siblings(".btn-change-file").removeClass('hide');
                $("#"+id).siblings(".btn-upload-file").html("").addClass('showimage').prepend('<img src="/images/tick-white.png" alt="">');


                let self=this;
                var files = e.target.files || e.dataTransfer.files;
                if(files.length >0){
                    const new_object_value = {
                        [name]: e.target.files[0]
                    };
                    Object.assign(this.form,new_object_value);

                }else{
                    const new_object_value = {
                        [name]: ''
                    };
                    Object.assign(this.form,new_object_value);
                }

            },
            getOnboardUserDetails(){
                axios.post('/apiV2/digitalOnboarding/getOnboardingUserDetails',{companyId:this.form.companyId})
                .then(res => {
                    if(res.status == 200){
                        if ( res.data.code == 200 ) {
                            this.company_details = res.data.data.company;
                            this.uploaded_documents = res.data.data.company_documents;
                            this.company_users = res.data.data.company[0];
                            this.documents_bucket_path = res.data.data.documents_bucket_path;
                            this.sample_documents_bucket_path = res.data.data.sample_documents_bucket_path;

                            const companyExtension = res.data.data.company_extension;
                            if (companyExtension){
                                this.form.bankName = companyExtension.bank_name;
                                this.form.accountNumber = companyExtension.account_number;
                                this.form.accountTitle = companyExtension.account_title;
                            }
                            9
                            if(typeof(this.company_users.cnic_front_path) != "undefined" && this.company_users.cnic_front_path !== null) {
                                var fileName = 'Uploaded';
                                $("#new_cnic_front").siblings(".btn-change-file").removeClass('hide');
                                $("#new_cnic_front").siblings(".uploaded-file").html(fileName);
                                $("#new_cnic_front").siblings(".btn-upload-file").html("").addClass('showimage').prepend('<img src="/images/tick-white.png" alt="">');

                            }
                            if(typeof(this.company_users.cnic_back_path) != "undefined" && this.company_users.cnic_back_path !== null) {
                                var fileName = 'Uploaded';
                                $("#new_cnic_back").siblings(".btn-change-file").removeClass('hide');
                                // $("#new_cnic_back").siblings(".btn-upload-file").html("Re-Upload");
                                $("#new_cnic_back").siblings(".uploaded-file").html(fileName);
                                $("#new_cnic_back").siblings(".btn-upload-file").html("").addClass('showimage').prepend('<img src="/images/tick-white.png" alt="">');

                            }
                           $.each(this.uploaded_documents, (key, value) => {
                               var uploaded_doc_id = value.id;
                                $("#static_"+uploaded_doc_id).siblings(".btn-change-file").removeClass('hide');
                               if(value.status == 'PENDING'){
                                    var fileName = 'Uploaded - Pending';
                                    $("#static_"+uploaded_doc_id).siblings(".btn-upload-file").html("").addClass('showimage').prepend('<img src="/images/tick-white.png" alt="">');
                                } else {
                                    var fileName = 'Uploaded - Approved';
                                    $("#static_"+uploaded_doc_id).siblings(".btn-upload-file").html("").addClass('showimageSuccess').prepend('<img src="/images/tick-white.png" alt="">');
                                }
                                $("#static_"+uploaded_doc_id).siblings(".uploaded-file").html(fileName);
                                    
                                });
                            } else {
                                this.showAlertBox('error','Error to load form data');
                            }

                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            getRequiredDocuments(){
                this.$Progress.start();
                axios.get('/apiV2/digitalOnboarding/getDocuments?companyId='+this.form.companyId)
                    .then(res => {
                        if(res.status == 200){
                            $.each(res.data.data, (key, value) => {
                                var doc_name = value.doc_name;
                                const new_object_value = {
                                    [doc_name]: []
                                };
                                Object.assign(this.form,new_object_value);
                            });
                            this.required_documents = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            updateCompanyDocuments() {
                this.disableButton('btn-submit','Submitting…',true);
                let newForm=new FormData();
                newForm.append('companyId',this.form.companyId);
                $.each(this.form, (key, value) => {
                    newForm.append(key,value);
                });
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                axios.post('/apiV2/digitalOnboarding/updateDocuments',newForm, config)
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == '200'){
                                this.$router.push('/editOnboardedCompanyUsers/'+res.data.data.company_id);
                                this.showToastBox('success', 'Documents successfully updated.');
                                this.$Progress.finish();
                            }else{
                                var error_msg = '';
                                error_msg = '<b>Following documents are required:</b>'+'\n';
                                $.each(res.data.data, (key, value) => {
                                    error_msg += value +'\n';
                                });
                                this.showAlertBox('error',error_msg);
                                this.disableButton('btn-submit','Submit',false);
                                this.$Progress.fail();
                            }
                        }else{
                            this.$Progress.fail();
                            this.disableButton('btn-submit','Submit',false);
                            this.showAlertBox('error','Some problem in you form data');
                        }
                    }).then(res=>{
                    this.getOnboardUserDetails();
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(err => {
                        this.disableButton('btn-submit','Submit',false);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in you form data');
                    });

            },
            addMoreFields(row){
                this.rows.push(row);
            },
            removeField(index){
                $('div[value='+index+']').remove();
            }
        },
        mounted() {
            this.$Progress.start();
            this.crud_company = true;
            this.form.companyId = this.$route.params.id;
            this.getRequiredDocuments();
            this.getOnboardUserDetails();
            this.$Progress.finish();
            // this.can('crud_company').then(result => {
            //     this.crud_company = result.crud_company;
            // }).then(result => {
            //     if(this.crud_company == true){
            //         this.form.companyId = this.$route.params.id;
            // 		this.getRequiredDocuments();
            // 		this.getOnboardUserDetails();
            //         this.$Progress.finish();
            //     }else{
            //         this.$Progress.finish();
            //     }
            // });
        },
    }
</script>

<style>
    .remove-fields {
        padding: 11px 15px;
        border: 0;
        background: #fd7e14;
        color: #fff;
        line-height: 17px;
        border-radius: 8px;
        float: right;
        margin-left: 10px;
        cursor: pointer;
    }

    .visibility-hidden {
        visibility: hidden;
    }
</style>
